// extracted by mini-css-extract-plugin
export default {"root":"MainLayout_root__zcUgK","sidebar":"MainLayout_sidebar__ctESw","content":"MainLayout_content__6tuZM","noPadding":"MainLayout_noPadding__AqNM4"};